import { render, staticRenderFns } from "./AreaProduct.vue?vue&type=template&id=21235fd4&scoped=true"
import script from "./AreaProduct.vue?vue&type=script&lang=js"
export * from "./AreaProduct.vue?vue&type=script&lang=js"
import style0 from "./AreaProduct.vue?vue&type=style&index=0&id=21235fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21235fd4",
  null
  
)

export default component.exports